import React, { useState, Fragment } from 'react';
import { Row, Input, FormGroup, Label, Form } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';

export default function BeddingOption({
  option,
  isExtensional,
  roomData,
  setRoomData,
  roomindex
}) {
  const [bedarrangments, setbedarrangments] = useState({ bedArrangements: [] });

  //TODO: Add more bed type
  // let single;
  // let double;
  // let king;

  // useEffect(() => {

  //   if (option.beds) {
  //     single = option.beds.find(
  //       bed => bed.type.toLowerCase() === 'single'
  //     );
  //     double = option.beds.find(
  //       bed => bed.type.toLowerCase() === 'double'
  //     );
  //     king = option.beds.find(bed => bed.type.toLowerCase() === 'king');
  //   }
  // }, []);

  const handleChangeBed = (index, e) => {
    e.persist();
    //const values = [...roomData.bedArrangements];
    let bedding = [...roomData.bedArrangements];
    //values[index].beds=
    if (bedding[index].length === 0) {
      const finalResult = [];
      finalResult.push({ type: e.target.name, count: e.target.value });
      bedding[index].push({ name: 'test', beds: finalResult });
    } else {
      if (e.target.value === '0' || e.target.value === '') {
        for (var i = 0; i < bedding[index].beds.length; i++) {
          if (bedding[index].beds[i].type.toLowerCase() === e.target.name.toLowerCase()) {
            bedding[index].beds.splice(i, 1);
          }
        }
      } else {
        var found = false;
        for (var i = 0; i < bedding[index].beds.length; i++) {
          if (bedding[index].beds[i].type.toLowerCase() === e.target.name.toLowerCase()) {
            bedding[index].beds[i].count = e.target.value;
            found = true;
          }
        }
        if (!found) {
          bedding[index].beds.push({ type: e.target.name, count: e.target.value });
        }
      }
    }


    setbedarrangments({
      ...bedarrangments,
      bedArrangements: bedding,
    });

    setRoomData({
      ...roomData,
      bedArrangements: bedding,
    });
  };

  return (
    <Fragment>
      {isExtensional ? (
        <Form>
          <FormGroup>
            <Row>
              <Colxx sm={12} className="md-3">
                <h4>Option</h4>
                <Label>
                  What kind of beds are available in this room?
                  {/* <IntlMessages id="forms.state" /> */}
                </Label>
              </Colxx>

              <Colxx sm={9} className="md-0">
                <Input
                  type="text"
                  defaultValue="Single bed / 90-130 cm wide"
                  disabled
                  style={{ padding: '5px' }}
                />
              </Colxx>
              <Colxx sm={3} className="md-0">
                <FormGroup>
                  <Input
                    type="number"
                    min={0}
                    name="single"
                    onChange={event => handleChangeBed(roomindex, event)}
                    defaultValue={
                      option.beds.find(
                        bed => bed.type.toLowerCase() === 'single'
                      )
                        ? option.beds.find(
                          bed => bed.type.toLowerCase() === 'single'
                        ).count
                        : 0
                    }
                    style={{ padding: '5px' }}
                  />
                </FormGroup>
              </Colxx>
              <Colxx sm={9}>
                <Input
                  type="text"
                  defaultValue="Double bed / 131-150 cm wide"
                  disabled
                  style={{ padding: '5px' }}
                />
              </Colxx>
              <Colxx sm={3}>
                <FormGroup>
                  <Input
                    type="number"
                    min={0}
                    name="double"
                    onChange={event => handleChangeBed(roomindex, event)}
                    defaultValue={
                      option.beds.find(
                        bed => bed.type.toLowerCase() === 'double'
                      )
                        ? option.beds.find(
                          bed => bed.type.toLowerCase() === 'double'
                        ).count
                        : 0
                    }
                    style={{ padding: '5px' }}
                  />
                </FormGroup>
              </Colxx>
              <Colxx sm={9}>
                <Input
                  type="text"
                  defaultValue="Large bed (King size) / 151-180 cm wide"
                  disabled
                  style={{ padding: '5px' }}
                />
              </Colxx>
              <Colxx sm={3}>
                <FormGroup>
                  <Input
                    type="number"
                    min={0}
                    name="king"
                    onChange={event => handleChangeBed(roomindex, event)}
                    defaultValue={
                      option.beds.find(bed => bed.type.toLowerCase() === 'king')
                        ? option.beds.find(
                          bed => bed.type.toLowerCase() === 'king'
                        ).count
                        : 0
                    }
                    style={{ padding: '5px' }}
                  />
                </FormGroup>
              </Colxx>
              <Colxx sm={9}>
                <Input
                  type="text"
                  defaultValue="Extra-large double bed (Super-king size) / 181-210 cm wide"
                  disabled
                  style={{ padding: '5px' }}
                />
              </Colxx>
              <Colxx sm={3}>
                <FormGroup>
                  <Input
                    type="number"
                    name="superking"
                    onChange={event => handleChangeBed(roomindex, event)}
                    defaultValue={
                      option.beds.find(
                        bed => bed.type.toLowerCase() === 'superking'
                      )
                        ? option.beds.find(
                          bed => bed.type.toLowerCase() === 'superking'
                        ).count
                        : 0
                    }
                    min={0}
                    style={{ padding: '5px' }}
                  />
                </FormGroup>
              </Colxx>
              <Colxx sm={9}>
                <Input
                  type="text"
                  defaultValue="Bunk bed / Variable Size"
                  disabled
                  style={{ padding: '5px' }}
                />
              </Colxx>
              <Colxx sm={3}>
                <FormGroup>
                  <Input
                    type="number"
                    name="bunk"
                    onChange={event => handleChangeBed(roomindex, event)}
                    defaultValue={
                      option.beds.find(bed => bed.type.toLowerCase() === 'bunk')
                        ? option.beds.find(
                          bed => bed.type.toLowerCase() === 'bunk'
                        ).count
                        : 0
                    }
                    min={0}
                    style={{ padding: '5px' }}
                  />
                </FormGroup>
              </Colxx>
              <Colxx sm={9}>
                <Input
                  type="text"
                  defaultValue="Sofa bed / Variable Size"
                  disabled
                  style={{ padding: '5px' }}
                />
              </Colxx>
              <Colxx sm={3}>
                <FormGroup>
                  <Input
                    type="number"
                    name="sofasingle"
                    onChange={event => handleChangeBed(roomindex, event)}
                    defaultValue={
                      option.beds.find(
                        bed => bed.type.toLowerCase() === 'sofasingle'
                      )
                        ? option.beds.find(
                          bed => bed.type.toLowerCase() === 'sofasingle'
                        ).count
                        : 0
                    }
                    min={0}
                    style={{ padding: '5px' }}
                  />
                </FormGroup>
              </Colxx>
              <Colxx sm={9}>
                <Input
                  type="text"
                  defaultValue="Futom mat/ Variable Size"
                  disabled
                  style={{ padding: '5px' }}
                />
              </Colxx>
              <Colxx sm={3}>
                <FormGroup>
                  <Input
                    type="number"
                    name="sofadouble"
                    onChange={event => handleChangeBed(roomindex, event)}
                    defaultValue={
                      option.beds.find(
                        bed => bed.type.toLowerCase() === 'sofadouble'
                      )
                        ? option.beds.find(
                          bed => bed.type.toLowerCase() === 'sofadouble'
                        ).count
                        : 0
                    }
                    min={0}
                    style={{ padding: '5px' }}
                  />
                </FormGroup>
              </Colxx>
              <Colxx sm={9}>
                <Input
                  type="text"
                  defaultValue="Queen bed"
                  disabled
                  style={{ padding: '5px' }}
                />
              </Colxx>
              <Colxx sm={3}>
                <FormGroup>
                  <Input
                    type="number"
                    name="queen"
                    onChange={event => handleChangeBed(roomindex, event)}
                    defaultValue={
                      option.beds.find(
                        bed => bed.type.toLowerCase() === 'queen'
                      )
                        ? option.beds.find(
                          bed => bed.type.toLowerCase() === 'queen'
                        ).count
                        : 0
                    }
                    min={0}
                    style={{ padding: '5px' }}
                  />
                </FormGroup>
              </Colxx>
              <Colxx sm={9}>
                <Input
                  type="text"
                  defaultValue="Double bunk with single bunk overhead"
                  disabled
                  style={{ padding: '5px' }}
                />
              </Colxx>
              <Colxx sm={3}>
                <FormGroup>
                  <Input
                    type="number"
                    name="doublebunk"
                    onChange={event => handleChangeBed(roomindex, event)}
                    defaultValue={
                      option.beds.find(
                        bed => bed.type.toLowerCase() === 'doublebunk'
                      )
                        ? option.beds.find(
                          bed => bed.type.toLowerCase() === 'doublebunk'
                        ).count
                        : 0
                    }
                    min={0}
                    style={{ padding: '5px' }}
                  />
                </FormGroup>
              </Colxx>
              <Colxx sm={9}>
                <Input
                  type="text"
                  defaultValue="Trundle bed"
                  disabled
                  style={{ padding: '5px' }}
                />
              </Colxx>
              <Colxx sm={3}>
                <FormGroup>
                  <Input
                    type="number"
                    name="trundle"
                    onChange={event => handleChangeBed(roomindex, event)}
                    defaultValue={
                      option.beds.find(
                        bed => bed.type.toLowerCase() === 'trundle'
                      )
                        ? option.beds.find(
                          bed => bed.type.toLowerCase() === 'trundle'
                        ).count
                        : 0
                    }
                    min={0}
                    style={{ padding: '5px' }}
                  />
                </FormGroup>
              </Colxx>
              <Colxx sm={9}>
                <Input
                  type="text"
                  defaultValue="King single bed"
                  disabled
                  style={{ padding: '5px' }}
                />
              </Colxx>
              <Colxx sm={3}>
                <FormGroup>
                  <Input
                    type="number"
                    name="kingsingle"
                    onChange={event => handleChangeBed(roomindex, event)}
                    defaultValue={
                      option.beds.find(
                        bed => bed.type.toLowerCase() === 'kingsingle'
                      )
                        ? option.beds.find(
                          bed => bed.type.toLowerCase() === 'kingsingle'
                        ).count
                        : 0
                    }
                    min={0}
                    style={{ padding: '5px' }}
                  />
                </FormGroup>
              </Colxx>
              <Colxx sm={9}>
                <Input
                  type="text"
                  defaultValue="Rollaway bed"
                  disabled
                  style={{ padding: '5px' }}
                />
              </Colxx>
              <Colxx sm={3}>
                <FormGroup>
                  <Input
                    type="number"
                    name="rollaway"
                    onChange={event => handleChangeBed(roomindex, event)}
                    defaultValue={
                      option.beds.find(
                        bed => bed.type.toLowerCase() === 'rollaway'
                      )
                        ? option.beds.find(
                          bed => bed.type.toLowerCase() === 'rollaway'
                        ).count
                        : 0
                    }
                    min={0}
                    style={{ padding: '5px' }}
                  />
                </FormGroup>
              </Colxx>
              <Colxx sm={9}>
                <Input
                  type="text"
                  defaultValue="Hollywood Twin"
                  disabled
                  style={{ padding: '5px' }}
                />
              </Colxx>
              <Colxx sm={3}>
                <FormGroup>
                  <Input
                    type="number"
                    name="hollywoodtwin"
                    onChange={event => handleChangeBed(roomindex, event)}
                    defaultValue={
                      option.beds.find(
                        bed => bed.type.toLowerCase() === 'hollywoodtwin'
                      )
                        ? option.beds.find(
                          bed => bed.type.toLowerCase() === 'hollywoodtwin'
                        ).count
                        : 0
                    }
                    min={0}
                    style={{ padding: '5px' }}
                  />
                </FormGroup>
              </Colxx>
              <Colxx sm={9}>
                <Input
                  type="text"
                  defaultValue="Four Poster King"
                  disabled
                  style={{ padding: '5px' }}
                />
              </Colxx>
              <Colxx sm={3}>
                <FormGroup>
                  <Input
                    type="number"
                    name="fourposterking"
                    onChange={event => handleChangeBed(roomindex, event)}
                    defaultValue={
                      option.beds.find(
                        bed => bed.type.toLowerCase() === 'fourposterking'
                      )
                        ? option.beds.find(
                          bed => bed.type.toLowerCase() === 'fourposterking'
                        ).count
                        : 0
                    }
                    min={0}
                    style={{ padding: '5px' }}
                  />
                </FormGroup>
              </Colxx>
              <Colxx sm={9}>
                <Input
                  type="text"
                  defaultValue="Canopy"
                  disabled
                  style={{ padding: '5px' }}
                />
              </Colxx>
              <Colxx sm={3}>
                <FormGroup>
                  <Input
                    type="number"
                    name="canopy"
                    onChange={event => handleChangeBed(roomindex, event)}
                    defaultValue={
                      option.beds.find(
                        bed => bed.type.toLowerCase() === 'canopy'
                      )
                        ? option.beds.find(
                          bed => bed.type.toLowerCase() === 'canopy'
                        ).count
                        : 0
                    }
                    min={0}
                    style={{ padding: '5px' }}
                  />
                </FormGroup>
              </Colxx>
            </Row>
          </FormGroup>
        </Form>
      ) : null}
    </Fragment>
  );
}
